const AbbsFurtherEducationData = {
    coursefee: "No",
    hostelfee: "Yes",
};
export default AbbsFurtherEducationData;
